<template>
    <div class="widget-box-wrap">
        <div class="widget-box">
            <div class="widget-box-head">
                <strong class="h2">Batting Stats</strong>
            </div>
            <div class="table-responsive">
                <table class="table player-stats-table">
                    <thead>
                        <tr>
                            <th style="text-align:left">Format</th>
                            <th>Matches</th>
                            <th>Innings</th>
                            <th>Notouts</th>
                            <th>Runs</th>
                            <th>Highest scores</th>
                            <th>Batting avg</th>
                            <th>Balls faced</th>
                            <th>Strike rate</th>
                            <th>Centuries</th>
                            <th>Fifties</th>
                            <th>Fours</th>
                            <th>Sixes</th>
                            <th>Catches</th>
                            <th>Stumps</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="index in battingstats" :key="index.type">
                            <td style="text-align:left">{{index.type.toUpperCase()}}</td>
                            <td>{{index.matches}}</td>
                            <td>{{index.innings}}</td>
                            <td>{{index.notouts}}</td>
                            <td>{{index.runs}}</td>
                            <td>{{index.highestscores}}</td>
                            <td>{{index.battingavg}}</td>
                            <td>{{index.ballsfaced}}</td>
                            <td>{{index.strikerate}}</td>
                            <td>{{index.centuries}}</td>
                            <td>{{index.fifties}}</td>
                            <td>{{index.fours}}</td>
                            <td>{{index.sixes}}</td>
                            <td>{{index.catches}}</td>
                            <td>{{index.stumps}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="widget-box">
            <div class="widget-box-head">
                <strong class="h2">Bowling Stats</strong>
            </div>
            <div class="table-responsive">
                <table class="table player-stats-table">
                    <thead>
                        <tr>
                            <th style="text-align:left">Format</th>
                            <th>Matches</th>
                            <th>Innings</th>
                            <th>Balls</th>
                            <th>Runs</th>
                            <th>Wickets</th>
                            <th>Best balling   </th>
                            <th>Best ball match</th>
                            <th>Bowling avg</th>
                            <th>Economyrate</th>
                            <th>Bowling strikerate</th>
                            <th>Wkt4</th>
                            <th>Wkt5</th>
                            <th>Wkt10</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="index in bowlingstats" :key="index.type">
                            <td style="text-align:left">{{index.type.toUpperCase()}}</td>
                            <td>{{index.matches}}</td>
                            <td>{{index.innings}}</td>
                            <td>{{index.balls}}</td>
                            <td>{{index.runs}}</td>
                            <td>{{index.wickets}}</td>
                            <td>{{index.bestballing}}</td>
                            <td>{{index.bestballmatch}}</td>
                            <td>{{index.bowlingavg}}</td>
                            <td>{{index.economyrate}}</td>
                            <td>{{index.bowlingstrikerate}}</td>
                            <td>{{index.wkt4}}</td>
                            <td>{{index.wkt5}}</td>
                            <td>{{index.wkt10}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    export default {
        name: 'Battingbowlingstats',

        data() {
            return {
                playerStats: [],
                battingstats: [],
                bowlingstats: [],
                age: ''
            }
        },
        metaInfo() {

            let title = `${Components['playerDetail'].player.full_name}  Batting Bowling Stats ` + " - PlanetCricket.com";
            let description = `Get the latest ${Components['playerDetail'].player.full_name} - Batting Bowling Stats ` + " - PlanetCricket.com";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {

                return this.$axios
                        .get(this.$PLAYER_STATS_API.replace(':player', this.$route.params.player))
                        .then(response => {
                            this.is_data_ready = true
                            this.playerStats = response.data.result || []
                            this.battingstats = response.data.result.playerBatstats || []
                            this.bowlingstats = response.data.result.playerBowlstats || []

                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
        }
    }
</script>